import { Option } from "../../components/Modals/OptionModal";

export default [
    { label: "ON", key: "on" },
    { label: "OFF", key: "off" },
] as Option[];
